import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const AndreasNotes = () => (
  <MarkdownPage file="AndreasNotes.md" showMermaid />
);
